import { useEffect } from 'react'
import { EventType } from 'commons/utils/event'

/**
 * Hook to create some event listener
 * @param eventName name of the event
 * @param eventCallback callback to be called when some evets was received
 * @returns
 */
const useEventListener = <T>(eventName: EventType, eventCallback: (ev: CustomEvent<T>) => void) => {
  useEffect(() => {
    window.addEventListener(eventName, eventCallback as unknown as EventListener)
    return () => {
      window.removeEventListener(eventName, eventCallback as unknown as EventListener)
    }
  }, [])
}

export default useEventListener
